import { Tooltip } from "antd"
import { Icon } from "ui/Icon"
import PropTypes from "prop-types"  

export const InfoTooltip = ({ title }) => {
  return (
    <Tooltip title={title} placement="bottom">
      <Icon type="feather" name="Info" width={20} height={20} />
    </Tooltip>
  )
}

InfoTooltip.propTypes = {
  title: PropTypes.string,
}

